import { TopWorkflowsResponse } from '@/types/composer-dashboard';
import { apiRequest } from '@/utils/api-request';

export async function getTopWorkflows(
  orgId: string,
  labelIds?: string[],
): Promise<TopWorkflowsResponse> {
  const params = labelIds?.length
    ? '?' +
      labelIds.map((id) => `label_ids=${encodeURIComponent(id)}`).join('&')
    : '';

  const response = await apiRequest<TopWorkflowsResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/workflows/top${params}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch top workflows');
  }

  return response.data;
}
